<template>
  <div class="inline-flex flex-col items-center">
    <span
      :aria-label="status"
      :class="[
        size === 'small' ? 'h-6 w-6' : '',
        size === 'medium' ? 'h-8 w-8' : '',
        size === 'standard' ? 'h-10 w-10' : '',
        size === 'large' ? 'h-12 w-12' : '',
        size === 'xl' ? 'h-16 w-16' : '',
        statusColorClass
      ]"
      :style="iconMaskStyle"
      role="img"
    />
  </div>
</template>

<script lang="ts" setup>
import type { ConnectorIconType } from '@infuse/ui/domain';
import { EViolinBackgroundColorClasses, EViolinStatus } from '@infuse/ui/utils';
import { computed } from 'vue';

interface Props {
  size?: 'small' | 'medium' | 'standard' | 'large' | 'xl';
  status?: EViolinStatus;
  type?: ConnectorIconType;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'standard',
  status: EViolinStatus.AVAILABLE,
  type: 'TYP2'
});

const imageUrl = computed(() => {
  return `/connector/${props.type}/Outline.svg`;
});

const statusColorClass = computed(() => {
  return EViolinBackgroundColorClasses[props.status] ?? EViolinBackgroundColorClasses[EViolinStatus.INACTIVE];
});

const iconMaskStyle = computed(() => ({
  WebkitMaskImage: `url(${imageUrl.value})`,
  maskImage: `url(${imageUrl.value})`,
  WebkitMaskRepeat: 'no-repeat',
  maskRepeat: 'no-repeat',
  WebkitMaskPosition: 'center',
  maskPosition: 'center',
  WebkitMaskSize: 'contain',
  maskSize: 'contain'
}));

</script>
